export default __webpack_public_path__ + "static/media/PTAR_DK.ea3d42c0.png";